import { render, staticRenderFns } from "./TestPaperZzedit.vue?vue&type=template&id=3b93a6e9&scoped=true"
import script from "./TestPaperZzedit.vue?vue&type=script&lang=js"
export * from "./TestPaperZzedit.vue?vue&type=script&lang=js"
import style0 from "./TestPaperZzedit.vue?vue&type=style&index=0&id=3b93a6e9&prod&lang=less"
import style1 from "./TestPaperZzedit.vue?vue&type=style&index=1&id=3b93a6e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b93a6e9",
  null
  
)

export default component.exports